import { createReducer, on } from '@ngrx/store';
import { IGestiuniState, initialGestiuniState } from './gestiuni.state';
import { GestiuniError, GestiuniLoaded, GestiuniLoading } from './gestiuni.actions';

export const initialState: IGestiuniState = {
  gestiuni: [],
  gestiuniById: {},
  loading: false,
};

const setGestiuni = (state: IGestiuniState, { gestiuni }: { gestiuni: [] }) => {
  let newState: IGestiuniState = {
    ...state,
    gestiuni,
    loading: false,
  };
  return newState;
}

const _GestiuniReducer = createReducer<IGestiuniState>(
  initialGestiuniState,

   on(GestiuniLoading, (state) => ({
     ...state,
     loading: true,
   })),

   on(GestiuniError, (state) => ({
    ...state,
    loading: false,
  })),
  
  on(GestiuniLoaded, setGestiuni),
);

export function gestiuniReducer(state: IGestiuniState, action): IGestiuniState {
  return _GestiuniReducer(state, action);
}
